import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import Button from "../global/Button";
import {
  useResendCodeMutation,
  useVerificationMutation,
} from "../../lib/redux/services/sections/Auth";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { toastMessage } from "../../utils/utils";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

type FormInput = {
  code1: string;
  code2: string;
  code3: string;
  code4: string;
};

type propsType = {
  verification_type?: "register" | "reset";
};

const EmailConfirmForm = ({ verification_type = "register" }: propsType) => {
  const { Auth, shared }: DictionaryType = useGetDictionary();
  const location = useLocation();
  console.log(location);
  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<FormInput>();
  const [timer, setTimer] = useState(120); // 2 minutes in seconds
  const [isResendActive, setIsResendActive] = useState(false);
  const navigate = useNavigate();
  const [verification] = useVerificationMutation();
  const [resend] = useResendCodeMutation();

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      setIsResendActive(true);
    }
  }, [timer]);

  console.log(location.state?.email);
  const onSubmit = async (data: FormInput) => {
    const confirmationCode = `${data.code1}${data.code2}${data.code3}${data.code4}`;

    const formData = !location?.state
      ? {
        fcmToken:localStorage.getItem('fcmToken') || '',
          account_id: localStorage.getItem("mocion-admin-id"),
          verification_code: confirmationCode,
        }
      : {
        fcmToken:localStorage.getItem('fcmToken') || '',
          account_id: 0,
          verification_code: confirmationCode,
          reset_password: true, // true when verification code is for pass reset
          email: location.state.email, // in case of reset password set this and set account_id=0
        };

    try {
      const data = await toast.promise(
        verification(formData).unwrap(),
        toastMessage()
      );

      if (location.state) {
        navigate("/auth/forget-password", {
          state: { email: location.state.email },
        });
        console.log("Hello");
      } else {
        localStorage.setItem("token", data.access_token);
        // localStorage.removeItem("password");
        navigate("/club-settings/organization");
      }
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  const handleResend = async () => {
    setTimer(120); // Reset timer to 2 minutes
    setIsResendActive(false);
    const userData = {
      account_id: localStorage.getItem("mocion-admin-id"),
    };
    try {
      const data = await toast.promise(resend(userData).unwrap(), {
        pending: "Resend Code...",
        success: "Code sent successful!",
        error: {
          render({ data }: any) {
            return (
              data?.data?.message || "An error occurred during Resend Code."
            );
          },
        },
      });
    } catch (error) {
      console.error("Login error:", error);
    }
  };

  const handleInputFocus = (
    e: React.ChangeEvent<HTMLInputElement>,
    nextFieldId: string
  ) => {
    if (e.target.value.length === 1) {
      const nextField = document.getElementById(nextFieldId);
      nextField?.focus();
    }
  };

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
      2,
      "0"
    )}`;
  };

  return (
    <div className="flex flex-col items-center justify-center mt-16">
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col items-center gap-6"
      >
        <div className="flex gap-5">
          {["code1", "code2", "code3", "code4"].map((name, index) => (
            <Controller
              key={name}
              name={name as keyof FormInput}
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <input
                  {...field}
                  type="text"
                  maxLength={1}
                  placeholder="-"
                  className="w-24 h-[125px] caret-transparent  text-center text-3xl border rounded-lg focus:outline-none focus:ring-2  focus:ring-primary placeholder-primary"
                  onChange={(e) => {
                    field.onChange(e);
                    handleInputFocus(
                      e,
                      `code${index + 2}` // Move to the next input
                    );
                  }}
                  id={`code${index + 1}`}
                />
              )}
            />
          ))}
        </div>
        {Object.keys(errors).length > 0 && (
          <p className="text-red-500 text-sm">{shared.all_fileds_requried}</p>
        )}

        <div className="text-center mb-10 mt-4">
          <div className=" text-gray-600 flex flex-row gap-2 text-base">
            {/* {timer > 0 ? (
              <span>{formatTime(timer)} Min</span>
            ) : (
              <button
                type="button"
                className="text-red-500 font-semibold"
                onClick={handleResend}
              >
                Resend?
              </button>
            )} */}
            <span className="text-primary dark:text-white">
              {formatTime(timer)} {shared.min}
            </span>

            <button
              type="button"
              className="text-red-500 font-semibold"
              onClick={handleResend}
            >
              {shared.resend}?
            </button>
          </div>
        </div>

        <Button
          customeStyle="bg-primary text-white w-full rounded-full text-sm py-4  font-bold"
          text={shared.confirm}
          width="max-w-[350px] w-full"
          type="submit"
        />
      </form>
    </div>
  );
};

export default EmailConfirmForm;
